const PHASE_OF_DAY = {
  AFTERNOON_TIME: 15,
  MORNING_TIME: 12
}

export default PHASE_OF_DAY
